import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AppRoutes from "./AppRoutes";
// import "./assets/css/style.css";
import Toasters from "./components/toaster/toasters";
import GlobalPdfNotification from "./components/globalPdfNotification/globalPdfNotification";
import AuthProvider from "./contexts/authcontext";
import CartProvider from "./contexts/cartcontext";
import PdfProvider from "./contexts/pdfcontext";
import StripeWrapper from "./utils/stripeWrapper";
import ScrollToTop from "./utils/scrollToTop";
import CustomErrorBoundary from './utils/customErrorBoundary';
import { disableInspect } from './utils/disableInspect';
import '../src/assets/css/bootstrap.css';
import '../src/assets/css/lightslider.css';
import '../src/assets/css/style.css';
import '../src/assets/css/custom.css';
import '../src/assets/css/responsive.css';
import { shouldDisableInspect } from "./constants/userConstant";
import YotpoProvider from "./contexts/YotpoContext";
import Maintenance from "./pages/Maintenance/maintenance";

const YOTPO_APP_KEY = process.env.REACT_APP_YOTPO_APP_KEY || "";
const IS_MAINTENANCE_MODE = process.env.REACT_APP_MAINTENANCE_MODE === "true";

const App = () => {
  useEffect(() => {
    // Disable inspect for the entire application based on environment
    disableInspect(shouldDisableInspect);

    return () => {
      disableInspect(false);
    };
  }, []);

  if (IS_MAINTENANCE_MODE) {
    return <Maintenance />;
  }

  return (
    <Router>
      {YOTPO_APP_KEY ? (
        <YotpoProvider appKey={YOTPO_APP_KEY} reinitOnRouteChange={true}>
          <CartProvider>
            <PdfProvider>
              <AuthProvider>
                <StripeWrapper>
                  <ScrollToTop />
                  <CustomErrorBoundary>
                    <AppRoutes/>
                  </CustomErrorBoundary>
                  <GlobalPdfNotification />
                  <Toasters />
                  <ToastContainer />
                </StripeWrapper>
              </AuthProvider>
            </PdfProvider>
          </CartProvider>
        </YotpoProvider>
      ) : (
        <CartProvider>
          <PdfProvider>
            <AuthProvider>
              <StripeWrapper>
                <ScrollToTop />
                <CustomErrorBoundary>
                  <AppRoutes/>
                </CustomErrorBoundary>
                <GlobalPdfNotification />
                <Toasters />
                <ToastContainer />
              </StripeWrapper>
            </AuthProvider>
          </PdfProvider>
        </CartProvider>
      )}
    </Router>
  );
};

export default App;
